import * as React from 'react';
import { PropsWithChildren } from "react";
import styled from "styled-components";
import { colors } from '../colors/color';

type FormFieldMessageProps = {
    errorState?:boolean,
    style?: React.CSSProperties
}
export function FormFieldMessage(props:PropsWithChildren<FormFieldMessageProps>):JSX.Element
{
    return (
        <StyledDiv style={props.style} errorState={props.errorState===undefined ? false : props.errorState}>
            {props.children}
        </StyledDiv>
    );
}

const StyledDiv = styled.div<{errorState:boolean}>`
    ${ props => props.errorState && "margin: 4px 16px"};
    font-size:14px;
    font-weight: 400;
    line-height: 20px;
    color:${props => props.errorState ? colors.text.state.error : colors.text.normal };
`;